import { axiosInstance } from 'src/util/axios.js'

const useProjectsApi = () => {
  const getProjects = async ({ offset, limit }: { offset: number; limit: number }) => {
    try {
      const response = await axiosInstance.post('/blockchain-helpers/external/getProjects', {
        pagination: {
          limit,
          offset,
        },
      })

      return response.data.data
    } catch (err) {
      console.error('Get projects error', err)
    }
  }

  const importProject = async ({
    chain,
    network,
    tokenTicker,
    address,
  }: {
    chain: string
    network: string
    tokenTicker: string
    address: string
  }) => {
    try {
      const response = await axiosInstance.post('/blockchain-helpers/external/importTokenProject', {
        projectType: 'token',
        chain: chain.toLowerCase(),
        network,
        address,
        tokenTicker,
      })

      return response.data.data
    } catch (err) {
      console.error('Get projects error', err)
    }
  }

  return { getProjects, importProject }
}

export default useProjectsApi
